import { IBuscaDividaRequest } from './types';
import { IDivida } from 'interfaces/Divida';
import api from "../api";

export const buscaDividaService = async (data: IBuscaDividaRequest) => await api.post<IDivida[]>('busca-divida', data);